export const LOAD_USER = "LOAD_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const CHANGE_CITY = "CHANGE_CITY";

export const GET_FEATURED_PRODUCT = "GET_FEATURED_PRODUCT";
export const FEATURED_PRODUCT_ERROR = "FEATURED_PRODUCT_ERROR";

export const GET_GALLERY = "GET_GALLERY";
export const GALLERY_ERROR = "GALLERY_ERROR";
export const GET_TYPES = "GET_TYPES";
export const TYPES_ERROR = "TYPES_ERROR";

export const GET_TRENDS = "GET_TRENDS";
export const TRENDS_ERROR = "TRENDS_ERROR";

export const GET_COUPONS = "GET_COUPONS";
export const COUPONS_ERROR = "COUPONS_ERROR";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const HANDLE_ONE_PRODUCT_QUANTITY = "HANDLE_ONE_PRODUCT_QUANTITY";
export const PRODUCTS_ERROR = "RODUCTS_ERROR";

//Accesories
export const GET_ACCESORIES = "GET_ACCESORIES";
export const ACCESORIES_ERROR = "ACCESORIES_ERROR";
export const LOADING_ACCESSORIES = "LOADING_ACCESORIES";
export const DETAIL_ACCSSORIES = "DETAIL_ACCSSORIES";

export const GET_VIDEOS = "GET_VIDEOS";
export const VIDEOS_ERROR = "VIDEOS_ERROR";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const CATEGORIES_ERROR = "CATEGORIES_ERROR";

export const GET_CURRENCY = "GET_CURRENCY";
export const SET_CURRENCY = "SET_CURRENCY";
export const CURRENCY_ERROR = "CURRENCY_ERROR";

export const GET_PRODUCT_DETAIL = "GET_PRODUCT_DETAIL";
export const PRODUCT_DETAIL_ERROR = "PRODUCT_DETAIL_ERROR";

export const LOADING_CURRENCY = "LOADING_CURRENCY";
export const LOADING_PRODUCT_DETAIL = "LOADING_PRODUCT_DETAIL";
export const LOADING_CART = "LOADING_CART";
export const REMOVE_ALL_PRODUCTS = "REMOVE_ALL_PRODUCTS";
export const CART_ERROR = "CART_ERROR";

export const GET_SHIPPING_COST = "GET_SHIPPING_COST";
export const SHIPPING_COST_ERROR = "SHIPPING_COST_ERROR";
export const PAYMENT_ERROR = "PAYMENT_ERROR";

export const WISHLIST_ERROR = "WISHLIST_ERROR";
export const GET_WISHLIST = "GET_WISHLIST";
export const ADD_WISHLIST_ITEM = "ADD_WISHLIST_ITEM";
export const REMOVE_WISHLIST_ITEM = "REMOVE_WISHLIST_ITEM";

export const SHOPPING_HISTORY_ERROR = "SHOPPING_HISTORY_ERROR";
export const GET_SHOPPING_HISTORY = "GET_SHOPPING_HISTORY";

export const MY_ADDRESSES_ERROR = "MY_ADDRESSES_ERROR";
export const GET_MY_ADDRESSES = "GET_MY_ADDRESSES";
export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const EDIT_ADDRESS = "EDIT_ADDRESS";
export const REMOVE_ADDRESS = "REMOVE_ADDRESS";

export const GET_CHECKOUT = "GET_CHECKOUT";
export const SET_CHECKOUT = "SET_CHECKOUT";
export const REMOVE_CHECKOUT = "REMOVE_CHECKOUT";
export const CHECKOUT_ERROR = "CHECKOUT_ERROR";

export const GET_DEPARTAMENTS = "GET_DEPARTAMENTS";
export const ERROR_DEPARTAMENTS = "ERROR_DEPARTAMENTS";

export const GET_MUNICIPALITIES = "GET_MUNICIPALITIES";
export const ERROR_MUNICIPALITIES = "ERROR_MUNICIPALITIES";
